import clsx from 'clsx';
import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import { useLocation } from '@reach/router';
import { extractLanguage } from '../../helpers/common';
import { loadPipedriveWebForms, onPageInteraction } from '../../lib/utils';

export default function ContactFormComponent({ blok }) {
  const styles = clsx('blok-contact-form-component');

  const location = useLocation();
  const isContactPage = /^\/(en\/)?contact\/?$/.test(location.pathname);

  const currentLanguage = extractLanguage(location.pathname);

  const formID = currentLanguage === 'en'
    ? '2VqRgXb5NURsG5zksxEn6QASTXm1FifV6J9zlfJsqmbB2o59ibPNHgLAR6W4EZLFN'
    : '1rq7nu1iuL8GqUg2CxYDsAd24yA6hpZHaH3VrPWMEc5Iu6PjKdqT5ddGThTRuS2n9';

  const formRef = React.useRef(null);

  React.useEffect(() => {
    if (!formRef.current) return undefined;

    if (isContactPage) {
      loadPipedriveWebForms();
      return undefined;
    }

    return onPageInteraction(loadPipedriveWebForms);
  }, [formID, isContactPage]);

  return (
    <div {...storyblokEditable(blok)} className={styles}>
      <div
        className="pipedriveWebForms"
        id="contact-form"
        ref={formRef}
        key={formID}
      >
        <div
          className="pipedriveWebForms h-auto"
          data-pd-webforms={`https://webforms.pipedrive.com/f/${formID}`}
        />
      </div>
    </div>
  );
}
